import { c as _c } from "react/compiler-runtime";
import { FileCheckIcon } from '@shared/ui-components/svgs';
import styles from './topic-trigger-icon.module.scss';
export const TopicTriggerIcon = t0 => {
  const $ = _c(3);
  const {
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FileCheckIcon className={styles.trigger__icon} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span className={styles.trigger}>{t1}<span className={styles.trigger__text}>{label}</span></span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};